// extracted by mini-css-extract-plugin
export var pillWrapper = "_yi-0";
export var showOverflow = "_yi-1";